<template>
    <restaurant-details-block
        class="restaurant-details"
    >
        <restaurant-opening-hours
            :opening-hours="openingHours"
            :notice="openingHoursNotice"
            :sale-text="saleText"
        />

        <b-button
            v-if="internalLink || isExternalLink"
            class="view-menu-button"
            variant="primary"
            :to="internalLink"
            :href="viewMenuDetails.external_link"
            :target="isExternalLink ? '_blank' : null"
            :rel="isExternalLink ? 'noopener' : null"
            size="sm"
            v-test:menuButton
        >
            {{ viewMenuDetails.btn_text }}
        </b-button>

        <b-row>
            <b-col md="6">
                <restaurant-address
                    :address="address"
                />
            </b-col>

            <b-col
                v-if="tel"
                md="6"
            >
                <restaurant-phone-number
                    :tel="tel"
                />
            </b-col>
        </b-row>
    </restaurant-details-block>
</template>

<script>
    import RestaurantDetailsBlock from '../../molecules/RestaurantDetailsBlock/RestaurantDetailsBlock';
    import RestaurantPhoneNumber from '../RestaurantPhoneNumber/RestaurantPhoneNumber';
    import RestaurantAddress from '../RestaurantAddress/RestaurantAddress';
    import RestaurantOpeningHours from '../RestaurantOpeningHours/RestaurantOpeningHours';
    import RestaurantDetail from '../../molecules/RestaurantDetail/RestaurantDetail';

    export default {
        name: 'restaurant-details',

        components: {
            RestaurantDetailsBlock,
            RestaurantPhoneNumber,
            RestaurantAddress,
            RestaurantOpeningHours,
            RestaurantDetail,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            address: {
                type: String,
                required: true,
            },

            openingHours: {
                type: Object,
                default: () => ({}),
            },

            openingHoursNotice: {
                type: String,
                default: '',
            },

            tel: {
                type: String,
                default: '',
            },

            viewMenuDetails: {
                type: Object,
                default: () => ({}),
            },

            saleText: {
                type: String,
                default: '',
            },
        },

        computed: {
            /**
             * Check if view menu is external link.
             *
             * @returns {boolean}
             */
            isExternalLink() {
                return Boolean(this.viewMenuDetails?.external_link);
            },

            /**
             * Get internal link.
             *
             * @returns {string}
             */
            internalLink() {
                return this.viewMenuDetails?.page?.uri || null;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-opening-hours,
    .restaurant-address,
    .restaurant-phone-number,
    .view-menu-button {
        margin-bottom: 10px;
    }

    .view-menu-button {
        min-width: 160px;
    }
</style>
